import React from 'react'
import { Trans } from '@lingui/macro'
import './AudienceBox.less'
import IconPeople from '../../../../../components/common/icon/IconPeople'
import PeopleBar from '../../../../../components/dashboard/people-bar/PeopleBar'
import { ButtonOutline } from 'front-end/src/components'
import { linkBuilder } from '../../../../../../../shared/linkBuilder'
import { navigateTo } from '../../../../../app/util/appHistory'
import IconPlus2 from '../../../../../components/common/icon/IconPlus2'
import { TooltipHelpQuestion } from 'front-end/src/components/common/tooltip/TooltipHelp'
import { DASHBOARD_TABS } from 'front-end/src/pages/dashboards-page/manage/ManageDashboardPage'

interface IAudienceBoxProps {
  dashboardId: number
  isEmpty: boolean
  totalNumber: number
  commsPercent: number
  resourcePercent: number
}

const AudienceBox = ({
  dashboardId,
  isEmpty,
  totalNumber,
  commsPercent,
  resourcePercent
}: IAudienceBoxProps) => {
  return (
    <div className="DataSummaryGrid__item">
      <div className="Box AudienceBox">
        <div className="AudienceBox__tripleCircle">
          <IconPeople />
          {totalNumber}
          <span>
            <Trans>Audience</Trans>
          </span>
        </div>

        {isEmpty ? (
          <div className="AudienceBox__penetrationWrapper --empty">
            <div className="AudienceBox__penetration">
              <PeopleBar percentage={0} />
              <div className="AudienceBox__penetration__percent">
                <div className="AudienceBox__penetration__percent__desc">
                  <Trans>No audience defined</Trans>
                </div>
              </div>
            </div>
            <div>
              <ButtonOutline
                onClick={() =>
                  navigateTo(
                    linkBuilder.dashboardManage(dashboardId, DASHBOARD_TABS[2])
                  )
                }
                leftIcon={<IconPlus2 />}
              >
                <Trans>Define audience</Trans>
              </ButtonOutline>
            </div>
          </div>
        ) : (
          <div className="AudienceBox__penetrationWrapper">
            <div className="AudienceBox__penetration">
              <PeopleBar percentage={commsPercent} />
              <div className="AudienceBox__penetration__percent">
                {commsPercent}%
                <div className="AudienceBox__penetration__percent__desc">
                  <Trans>Comms engagement</Trans>
                </div>
                <div className="AudienceBox__penetration__percent__tip">
                  <TooltipHelpQuestion>
                    <Trans>
                      % of target audience that have reacted on your campaign
                      actions.
                    </Trans>
                  </TooltipHelpQuestion>
                </div>
              </div>
            </div>
            <div className="AudienceBox__penetration">
              <PeopleBar percentage={resourcePercent} />
              <div className="AudienceBox__penetration__percent">
                {resourcePercent}%
                <div className="AudienceBox__penetration__percent__desc">
                  <Trans>Resources engagement</Trans>
                </div>
                <div className="AudienceBox__penetration__percent__tip">
                  <TooltipHelpQuestion>
                    <Trans>
                      % of target audience that have engaged in your resources.
                    </Trans>
                  </TooltipHelpQuestion>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default AudienceBox
